import { Filters, GroupData, GroupMode, GroupType } from '@bringg/types';

import { orderExplorerRootStore } from '../../order-explorer/stores/order-explorer-root-store';
import { TableItem } from '../../shared/stores/groups/types';

const oneLevelGroupSet = new Set<GroupMode>([GroupMode.Team, GroupMode.Route, GroupMode.Driver, GroupMode.Fleet]);
const twoLevelsGroupSet = new Set<GroupMode>([GroupMode.TeamDriver, GroupMode.TeamRoute, GroupMode.FleetTeam]);

const masterGroups = new Set<GroupType>(['team']);
const subGroups = new Set<GroupType>(['driver', 'route']);

export const isOneLevelGroup = (groupMode: GroupMode) => oneLevelGroupSet.has(groupMode);
export const isTwoLevelsGroup = (groupMode: GroupMode) => twoLevelsGroupSet.has(groupMode);

export const isMasterGroup = (groupType: GroupType) => masterGroups.has(groupType);
export const isSubGroup = (groupType: GroupType) => subGroups.has(groupType);

const getParentGroup = (childGroup: GroupData): GroupData => {
	const { groups } = orderExplorerRootStore.getStore().orderExplorerStore.currentTableDefinition;

	return groups.find(pGroup => pGroup.groups?.find(cGroup => cGroup.id === childGroup.id));
};

const getGroupFilter = (group: GroupData): Partial<Filters> => {
	let key: keyof Filters;

	switch (group.group_type) {
		case 'driver':
			key = 'selectedUsers';
			break;
		case 'team':
			key = 'selectedTeams';
			break;
		case 'route':
			key = 'selectedRuns';
			break;
	}

	return {
		[key]: [group.data.id]
	} as any;
};

export const getGroupFilters = (group: GroupData): Filters => {
	const { groupMode } = orderExplorerRootStore.getStore().orderExplorerStore.currentTableDefinition;

	let filters = getGroupFilter(group);

	if (isTwoLevelsGroup(groupMode) && isSubGroup(group.group_type)) {
		const parent = getParentGroup(group);
		const parentFilters = getGroupFilter(parent);

		filters = {
			...filters,
			...parentFilters
		};
	}

	return filters as Filters;
};

export const isGroupRow = (_row: TableItem) => {
	return !!(_row as GroupData).group_type;
};

export const getLastGroup = (groups: GroupData[]): GroupData => {
	const lastGroup = groups[groups.length - 1];
	const lastNestedGroup = lastGroup.groups?.[lastGroup.groups?.length - 1];
	return lastNestedGroup || lastGroup;
};
